import React, { useContext } from "react";
import { Box } from "@mui/material";
import { AppContext } from "../../AppContextProvider";
import { RFQStatus } from "../../models/RFQStatus";
import RfqPrioritySelector from "./RfqPrioritySelector";

interface RfqPriorityCellProps {
  rfqId: number;
  priority: number;
  rfqStatus: RFQStatus;
}

const RfqPriorityCell: React.FC<RfqPriorityCellProps> = ({
  rfqId,
  priority,
  rfqStatus,
}) => {
  const { viewArchivedRfqs } = useContext(AppContext);

  const hidden =
    viewArchivedRfqs &&
    (rfqStatus === RFQStatus.CLOSED || rfqStatus === RFQStatus.CANCELLED);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <RfqPrioritySelector
        rfqId={rfqId}
        priority={priority}
        hidden={hidden}
      />
    </Box>
  );
};

export default RfqPriorityCell;
